import { useTranslation } from 'react-i18next';
import { DataTableSkeleton } from '@/components/data-table/data-table-skeleton';
import { ErrorBoundarySuspense } from '@/components/error-boundary-suspense';
import { useLotSizings } from './hooks/use-lot-sizings';
import { LotSizingsTable } from './lot-sizings-table';

export function LotSizings() {
  const { t } = useTranslation('lotSizings');
  const { queryKey } = useLotSizings();

  return (
    <div className='flex min-h-0 flex-1 flex-col'>
      <ErrorBoundarySuspense
        errorFallbackWrapper={<div className='mt-4 w-full max-w-md' />}
        loadingFallback={<DataTableSkeleton columnCount={6} rowCount={8} />}
        message={t('Unable to load lot sizings')}
        queryKey={queryKey}
      >
        <LotSizingsTable />
      </ErrorBoundarySuspense>
    </div>
  );
}
